<template>
  <b-card>
    <b-card-text>
      <b-row>
        <b-col>
          <p>
            <span v-if="!is_no_client && !!form">
              {{ form.name }}
            </span>
            <span v-if="is_no_client">
              {{ trans('client_form_intro') }}
            </span>
          </p>
        </b-col>
        <b-col v-if="!!invoice && canToggleNoClient" class="col-auto">
          <b-form-group>
            <b-form-checkbox :checked="is_no_client" switch class="danger" @change="toggleNoClient">
              <span class="text-danger">
                {{ trans(is_no_client ? 'no_client' : 'client') }}
                <small :title="noClientAbout + ' ' + trans('visible_only_administrators') + '.'" v-b-tooltip.hover>
                  <i class="fa fa-fw fa-info-circle"></i>
                </small>
              </span>
            </b-form-checkbox>
            <b-form-text v-if="busy">
              <i class="fa fa-fw fa-circle-notch fa-spin"></i>
              {{ trans('please_wait') }}
            </b-form-text>
            <b-form-text v-if="error" class="text-danger">
              {{ error }}
            </b-form-text>
          </b-form-group>
        </b-col>
        <b-col v-if="!organization.connected_client && !!organization.last_invoice_recipient && !recipient" class="col-auto">
          <p>
            <b-button
              v-if="!organization.auth_user"
              variant="link"
              class="p-0"
              @click="onClickClearForm"
            >
              {{ trans('this_is_not_you_clear_form') }}
            </b-button>
            <b-button
              v-if="!!organization.auth_user"
              variant="link"
              class="p-0 text-danger"
              @click="onClickClearForm"
            >
              {{ trans('clear_form') }}
            </b-button>
          </p>
        </b-col>
      </b-row>
    </b-card-text>

    <checkout-form
      v-if="!is_no_client && !!form"
      :organization="organization"
      :form="form"
      :recipient="recipient || invoice.recipient"
      :invoice="invoice"
      :initial-answers="answers"
      :url="getUrl(form)"
      show-previous
      force-partial-save
      :next-button-label="nextButtonLabel"
      :previous-button-label="previousButtonLabel"
      @previous="$emit('previous')"
      @invoice="onInvoice"
      @client="$emit('client', $event)"
    ></checkout-form>

    <div v-if="is_no_client">
      <p class="text-muted">
        {{ noClientAbout }}
      </p>
    </div>

    <b-row v-if="is_no_client" class="mt-4">
      <b-col>
        <b-button variant="outline-secondary" @click="$emit('previous')" :disabled="busy">
          {{ previousButtonLabel }}
        </b-button>
      </b-col>
      <b-col class="text-right">
        <b-button variant="branded" @click="$emit('next')" :disabled="busy">
          {{ nextButtonLabel }}
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
  import CheckoutForm from './../checkout-form/CheckoutForm'

  export default {
    props: {
      organization: Object,
      invoice: Object,
      recipient: Object,
      preventSwitchForm: {
        type: Boolean,
        default: false,
      },
      form: Object,
      nextButtonLabel: {
        type: String,
        default: trans('next'), // save or submit
      },
      previousButtonLabel: {
        type: String,
        default: trans('previous'), // cancel
      },
    },
    components: {
      CheckoutForm,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        lang: window.lang,
        busy: false,
        error: null,
        is_no_client: this.invoice.is_no_client,
      }
    },
    computed: {
      answers() {
        this.form.answers ?? null
      },
      noClientAbout() {
        return trans('no_client_about').replace(
          ':no_client',
          `${_.NO_CLIENT.name} (${_.NO_CLIENT.email})`
        )
      },
      canToggleNoClient() {
        return this.organization.auth_user &&
          this.organization.auth_user.microsite_permissions.can_toggle_no_client &&
          !!this.invoice && !!this.invoice.admin
      },
    },
    watch: {
      invoice() {
        this.is_no_client = this.invoice.is_no_client
      },
    },
    methods: {
      getUrl(form) {
        let url = `/org/${this.organization.id}/cart/form/${form.id}`
        return url
      },
      onClickClearForm() {
        this.busy = true
        this.error = false
        let url = `/org/${this.organization.id}/cart/form`
        axios.delete(url)
        .then(response => {
          this.busy = false
          this.$emit('invoice', response.data)
          this.$emit('last-invoice-recipient', null)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      toggleNoClient() {
        this.busy = true
        this.error = false
        let url = `/org/${this.organization.id}/cart/toggle_no_client`
        axios.post(url, {
          is_no_client: !this.invoice.is_no_client
        })
        .then(response => {
          this.busy = false
          this.$emit('invoice', response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })        
      },
      onInvoice(invoice) {
        this.$emit('invoice', invoice)
        this.$nextTick(() => {
          this.$emit('next')
        })
      },
    },
    mounted() {
      window.accountOwnerForm = this
    },
  }
</script>